import React, { useState, useEffect } from 'react';
import { Box, Typography, TextField, Button, Tab } from '@mui/material';
import { useHistory } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@mui/material';
import axiosInstance from '../utils/api';


const CompletedAudits = () => {


  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  
  const pass = queryParams.get('pass'); // e.g., 'true' or null
  const significantImprovement = queryParams.get('significantImprovement'); 
  const improvement = queryParams.get('improvement'); 

  const [audits, setAudits] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);

  const [filteredAudits, setFilteredAudits] = useState([]);
  const [filters, setFilters] = useState({
    job_ref: '',
    address: '',
    reason_names: '',
    audit_creation: '',
    assigned_resource: '',
    audit_score: '',
    locked_by:'',
  });
  const [loading, setLoading] = useState(true);
  const [reassignId, setReassignId] = useState(null);
  const [clearMessage, setClearMessage] = useState(null);
  const history = useHistory();

  const launchReassignDialog = (auditId,clear) => {
    setDialogOpen(true);
    setClearMessage(clear)
    setReassignId(auditId);
  };
// 936487
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);

  // const [fromDate, setFromDate] = useState(null);
  // const [toDate, setToDate] = useState(null);

  const handleConfirm = () => {
    setDialogOpen(false);
    axiosInstance.post('/api/reassign/', {
      audit_id: reassignId,
      clear: clearMessage ? true : false,
    }).then((response) => {
      if (response.status === 200) {
        if (clearMessage){
          // pop the audit from the list
          setFilteredAudits((prevAudits) => prevAudits.filter((audit) => audit.audit_id !== reassignId));
        }
      } else {
      }
    }).catch((error) => {
    });

  };
  const handleCancel = () => {
    setDialogOpen(false);
  };
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [resultType, setResultType] = useState(pass ? 'pass' : significantImprovement ? 'significant_improvement' : improvement ? 'improvement' : 'all');
  const [loadingExport, setLoadingExport] = useState(false);
  useEffect(() => {
    const savedFilters = JSON.parse(localStorage.getItem('completedJobAudits')) 

    if (savedFilters && Object.values(savedFilters).some((value) => value !== '')) {
      setLoading(true);
      setFilters(savedFilters);
      axiosInstance.post(`/api/filtered-audits/?result_type=${resultType}`, savedFilters).then((response) => {
        if (response.status === 200) {
          setFilteredAudits(response.data.audits);
        }

      })
      setLoading(false);
    }
    else{
    axiosInstance.get(`/api/audit/?page=${page}&page_size=${pageSize}&result_type=${resultType}`).then((response) => {
      if (response.status === 200) {
        setAudits(response.data.audits);
        setFilteredAudits(response.data.audits);
        setTotalPages(response.data.total_pages);
      }
      setLoading(false);
    });
  }
  }, [page, pageSize]);

  

  const handleClickAway = () => {
    // reload filters when clicking away from filter box 
    const savedFilters = JSON.parse(localStorage.getItem('completedJobAudits')) 
    if (savedFilters) {
      setFilters(savedFilters);
    }
    if (savedFilters && Object.values(savedFilters).some((value) => value !== '')) {
      setLoading(true);
      setFilters(savedFilters);
      axiosInstance.post(`/api/filtered-audits/?result_type=${resultType}`, savedFilters).then((response) => {
        if (response.status === 200) {
          setFilteredAudits(response.data.audits);
        }

      })
      setLoading(false);
      // setPageSize(response.data.audits.length); // Load more records to accommodate filters
    }
    else {
      axiosInstance.get(`/api/audit/?page=${page}&page_size=${pageSize}&result_type=${resultType}`).then((response) => {
        if (response.status === 200) {
          setAudits(response.data.audits);
          setFilteredAudits(response.data.audits);
        }
        setLoading(false);
      });
    }
    // axiosInstance.post('/api/filtered-audits/', savedFilters).then((response) => {
    //   if (response.status === 200) {
    //     setFilteredAudits(response.data.audits);
    //   }
    // });
  };

  useEffect(() => {
    // Load saved filters from local storage on component mount and apply them using the API
    const savedFilters = JSON.parse(localStorage.getItem('completedJobAudits'))

    // check if they are empty filters 
    if (savedFilters && Object.values(savedFilters).some((value) => value !== '')) {
      setLoading(true);
      setFilters(savedFilters);
      axiosInstance.post(`/api/filtered-audits/?result_type=${resultType}`, savedFilters).then((response) => {
        if (response.status === 200) {
          setFilteredAudits(response.data.audits);

        }

      })
      setLoading(false);
    }
    else {
      axiosInstance.get(`/api/audit/?page=${page}&page_size=${pageSize}&result_type=${resultType}`).then((response) => {
        if (response.status === 200) {
          setAudits(response.data.audits);
          setFilteredAudits(response.data.audits);
        }
        setLoading(false);
      });
    }
  }, []);

  const handleFilterChange = (event, column) => {
    const value = event.target.value;
    // Update the filters state
    const updatedFilters = {
      ...filters,
      [column]: value,
    };
    setFilters(updatedFilters);
    // save filters to local storage
    localStorage.setItem('completedJobAudits', JSON.stringify(updatedFilters));
    
    // Check if all filters are empty
    // const areFiltersEmpty = Object.values(updatedFilters).every((filterValue) => filterValue === '');

    // // Reset to original audits if all filters are empty
    // if (areFiltersEmpty) {
    //   setFilteredAudits(audits);
    //   return;
    // }

    // Apply filters directly using the updated value
    // const filtered = audits.filter((audit) => {
    //   return (
    //     (updatedFilters.job_ref ? audit.job_ref.toLowerCase().includes(updatedFilters.job_ref.toLowerCase()) : true) &&
    //     (updatedFilters.address ? `${audit.address?.HouseNumber ?? ''} ${audit.address?.HouseName ?? ''} ${audit.address?.Street ?? ''} ${audit.address?.Town ?? ''} ${audit.address?.Postcode ?? ''}`.toLowerCase().includes(updatedFilters.address.toLowerCase()) : true) &&
    //     (updatedFilters.reason_names ? audit.reason_names.some((reason) => reason.toLowerCase().includes(updatedFilters.reason_names.toLowerCase())) : true) &&
    //     (updatedFilters.audit_creation ? new Date(audit.created_at).toLocaleString().toLowerCase().includes(updatedFilters.audit_creation.toLowerCase()) : true) &&
    //     (updatedFilters.assigned_resource ? `${audit.first_name ?? ''} ${audit.last_name ?? ''}`.toLowerCase().includes(updatedFilters.assigned_resource.toLowerCase()) : true) &&
    //     (updatedFilters.audit_score ? (audit.overall_score ?? '').toLowerCase().includes(updatedFilters.audit_score.toLowerCase()) : true) && // Handle null overall_score &&
    //     (updatedFilters.locked_by ? `${audit.locked_by.first_name ?? ''} ${audit.locked_by.last_name ?? ''}`.toLowerCase().includes(updatedFilters.locked_by.toLowerCase()) : true)

    // setFilteredAudits(filtered);
  };

  if (loading) {
    return <Typography>Loading...</Typography>;
  }

  const exportAuditData = () => {
    setLoadingExport(true);
    var body = {
      from_date: fromDate,
      to_date: toDate,
    };
    axiosInstance.post('/api/mi?type=date_range', body, {
      responseType: 'blob', // Important for file download
      timeout: 180000, 
    })
    .then((response) => {
      // response.data is already a Blob
      const url = window.URL.createObjectURL(response.data);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'audit_data_export.csv'); // Set the file name
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url); // Clean up
      setLoadingExport(false);
    })
    .catch((error) => {
      setLoadingExport(false);
    });
  }


  const clearFilters = () => {
    setFilters({
      job_ref: '',
      address: '',
      reason_names: '',
      audit_creation: '',
      assigned_resource: '',
      audit_score: '',
      locked_by:'',
    });
    localStorage.removeItem('completedJobAudits');
    setFilteredAudits(audits);
  }

  
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        All jobs with completed audits {pass ? ' - Passed Audits' : significantImprovement ? ' - Significant Improvement Audits' : improvement ? ' - Improvement Audits' : ''}
      </Typography>
      <Typography variant="h6"  sx={{pl:1}} gutterBottom>
        Export Data
      </Typography>
      <Box sx={{ display: 'flex', gap: 2, mb: 2, alignItems: 'center' }}>
        <TextField
          label="From Date"
          type="date"
          value={fromDate || ''}
          onChange={(e) => setFromDate(e.target.value)}
          InputLabelProps={{ shrink: true }}
          size="small"
        />
        <TextField
          label="To Date"
          type="date"
          value={toDate || ''}
          onChange={(e) => setToDate(e.target.value)}
          InputLabelProps={{ shrink: true }}
          size="small"
        />
        <Button variant="contained" disabled={loadingExport} color="primary" onClick={exportAuditData} >
          {
            loadingExport ? 'Loading....' : 'Export Audit Data'
          }
        </Button> 

      </Box>
      <TableContainer component={Paper} sx={{ opacity: 0.9, width: '100%', overflow: 'hidden' }}>
        <Box sx={{ overflowX: 'auto', width: '100%' }}>
          <Table sx={{ minWidth: 1200 }}> {/* Enforce a minimum width for the table */}
            <TableHead>
              <TableRow>
                <TableCell>
                  {/* <ClickAwayListener onClickAway={handleClickAway}> */}
                    <TextField
                      label="Filter CW Ref"
                      variant="outlined"
                      size="small"
                      name="job_ref"
                      value={filters.job_ref}
                      onChange={(e) => handleFilterChange(e, 'job_ref')}
                      onBlur={handleClickAway}
                      fullWidth
                    />

                  {/* </ClickAwayListener> */}
                </TableCell>
                <TableCell>
                  <TextField
                    label="Filter Address"
                    variant="outlined"
                    size="small"
                    name="address"
                    value={filters.address}
                    onChange={(e) => handleFilterChange(e, 'address')}
                    onBlur={handleClickAway}

                    fullWidth
                  />
                </TableCell>
                <TableCell>
                  <TextField
                    label="Filter Reason Names"
                    variant="outlined"
                    size="small"
                    name="reason_names"
                    value={filters.reason_names}
                      onBlur={handleClickAway}
                      onChange={(e) => handleFilterChange(e, 'reason_names')}
                    fullWidth
                  />
                </TableCell>
                <TableCell>
                  <TextField
                    // label="Filter Audit Creation"
                    variant="outlined"
                    size="small"
                    type="date"
                    name="audit_creation"
                    value={filters.audit_creation}
                      onBlur={handleClickAway}
                      onChange={(e) => handleFilterChange(e, 'audit_creation')}
                    fullWidth
                  />
                </TableCell>
                <TableCell>
                  <TextField
                    label="Filter Assigned Resource"
                    variant="outlined"
                    size="small"
                    name="assigned_resource"
                    value={filters.assigned_resource}
                      onBlur={handleClickAway}
                      onChange={(e) => handleFilterChange(e, 'assigned_resource')}
                    fullWidth
                  />
                </TableCell>
                <TableCell>
                  <TextField
                    label="Filter Locked By"
                    variant="outlined"
                    size="small"
                    name="locked_by"
                    value={filters.locked_by}
                      onBlur={handleClickAway}
                      onChange={(e) => handleFilterChange(e, 'locked_by')}
                    fullWidth
                  />
                </TableCell>
                <TableCell>
                <TextField
                  label="Filter Audit Score"
                  variant="outlined"
                  size="small"
                  name="audit_score"
                  value={filters.audit_score}
                  onChange={(e) => handleFilterChange(e, 'audit_score')}
                      onBlur={handleClickAway}
                      fullWidth
                />
                </TableCell>
                <TableCell>
                  {Object.values(filters).some((value) => value !== '') && (
                    <Button variant="outlined" color="secondary" onClick={clearFilters}>
                      Clear Filters
                    </Button>
                  )}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell><strong>CW Ref</strong></TableCell>
                <TableCell><strong>Address</strong></TableCell>
                <TableCell><strong>Reason Name(s)</strong></TableCell>
                <TableCell><strong>Audit Creation</strong></TableCell>
                <TableCell><strong>Assigned Resource</strong></TableCell>
                <TableCell><strong>Locked By</strong></TableCell>
                <TableCell><strong>Audit Score</strong></TableCell>
                <TableCell><strong></strong></TableCell>
                <TableCell><strong></strong></TableCell>

              </TableRow>
            </TableHead>
            <TableBody>
              {filteredAudits.length > 0 ? (
                filteredAudits.map((audit) => (
                  <TableRow key={audit.audit_id}>
                    <TableCell>{audit.job_ref}</TableCell>
                    <TableCell>
                      {`${audit.address?.HouseNumber ?? ''} ${audit.address?.HouseName ?? ''} ${audit.address?.Street ?? ''} ${audit.address?.Town ?? ''} ${audit.address?.Postcode ?? ''}`.trim()}
                    </TableCell>
                    <TableCell>
                      {audit.reason_names.map((reason, index) => (
                        <span key={index}>
                          {reason}
                          {index < audit.reason_names.length - 1 ? ', ' : ''}
                        </span>
                      ))}
                    </TableCell>
                    <TableCell>{new Date(audit.created_at).toLocaleString()}</TableCell>
                    <TableCell>{audit.first_name + ' ' + audit.last_name}</TableCell>
                    <TableCell>{audit.locked_by.first_name + ' '+ audit.locked_by.last_name}</TableCell>
                    <TableCell>{audit.overall_score}</TableCell>
                    <TableCell>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => history.push(`/jobs/audit/${audit.audit_id}`)}
                      >
                        View Audit
                      </Button>
                    </TableCell>
                    <TableCell>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => launchReassignDialog(audit.audit_id, null)}
                        sx={{ mb: 1 }}
                      >
                        Re-Assign Audit
                      </Button>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => launchReassignDialog(audit.audit_id,'clear')}
                      >
                        Clear Audit Assignmnet
                      </Button>
                    </TableCell>

                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={6} align="center">
                    No match for the filter criteria.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
              <Button disabled={page <= 1} onClick={() => setPage(page - 1)}>Previous</Button>
              <Typography sx={{ mx: 2 }}>Page {page} of {totalPages}</Typography>
              <Button disabled={page >= totalPages} onClick={() => setPage(page + 1)}>Next</Button>
            </Box>
          </Table>
        </Box>
      </TableContainer>
       <Dialog open={dialogOpen} onClose={handleCancel}>
          <DialogTitle>Confirm Action</DialogTitle>
          <DialogContent>
            Are you sure you want to un-assign this audit? 
            {
              clearMessage ? ' This will clear the current assignment.' : ' Doing so will assign the audit to you.'
            }
            
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCancel} color="secondary">
              Cancel
            </Button>
            <Button onClick={handleConfirm} color="primary" variant="contained">
              Confirm
            </Button>
          </DialogActions>
        </Dialog>
    </Box>

    
  );
};

export default CompletedAudits;
